import { IKnmIndex } from 'APIPackage/KnmModule/interfaces/IKnmIndex';

export const isKnmMultiOrganizations = (knm: IKnmIndex | undefined) => {
  if (!knm) {
    return false;
  }

  return knm.organizationsInn.length > 1 || knm.organizationsName.length > 1 || knm.organizationsOgrn.length > 1;
};
